export default "/images/ab76999b65302a09be833e5ce3693bd1.avif";